import React from "react";
import {Badge} from "peggirkit";
import {EmployeeTimeEntry} from "@/data/entities/employee";
import {FormattedMessage} from "react-intl";

type Props = {
    timeEntry: EmployeeTimeEntry | null
};

const ClockedInFormatter = ({timeEntry}: Props) => {
    const isClockedOut = timeEntry === null || timeEntry.clockOut !== null;

    return (
        <Badge color={isClockedOut ? "secondary" : "success"}>
            <FormattedMessage id={isClockedOut ? "clockedOut" : "clockedIn"}/>
        </Badge>
    );
};

export default ClockedInFormatter;